import {
  EditorConfigContext,
  MediaLibrary,
  NewMediaLibraryFeaturesBanner
} from "@prismicio/editor-fields"
import { Box } from "@prismicio/editor-ui"
import { useRef } from "react"

import { staticEditorConfig } from "../app/editorConfig"
import { routeAnimationDuration } from "../app/routeAnimation"
import { mainContentMaxWidth } from "../document/documentLayout"
import { MediaLibraryPageHeader } from "./MediaLibraryPageHeader"

// Since this is a page outside of the document editor
// we can exclude specific document fields from the config
const { searchDocuments, uidField, ...simpleConfig } = staticEditorConfig

export function MediaLibraryPage() {
  const actionContainerRef = useRef<HTMLDivElement>(null)

  return (
    <Box
      flexDirection="column"
      animation={{ name: "fadeIn", duration: routeAnimationDuration }}
      maxHeight="100vh"
      backgroundColor="grey3"
    >
      <NewMediaLibraryFeaturesBanner maxWidth={mainContentMaxWidth} />
      <MediaLibraryPageHeader ref={actionContainerRef} />
      <Box
        justifyContent="center"
        overflow="hidden"
        padding={{ top: 16, right: 16, left: 16 }}
        height="100vh"
      >
        <Box maxWidth={mainContentMaxWidth} width="100%">
          <EditorConfigContext.Provider value={simpleConfig}>
            <MediaLibrary actionContainerRef={actionContainerRef} />
          </EditorConfigContext.Provider>
        </Box>
      </Box>
    </Box>
  )
}
